import { HeroSendSlot } from './send-journey/HeroSendSlot'
import { HeroLinkReadySlot } from './send-journey/HeroLinkReadySlot'

export function HeroCollage() {
  return (
    <div style={{ position: 'relative', height: 520 }}>
      <HeroSendSlot />

      <HeroLinkReadySlot />

      <div
        aria-hidden
        style={{
          position: 'absolute',
          top: 20,
          right: -10,
          width: 96,
          height: 96,
          background: 'var(--yellow)',
          border: 'var(--border-w) solid var(--ink)',
          boxShadow: 'var(--shadow-sm)',
          transform: 'rotate(8deg)',
          display: 'grid',
          placeItems: 'center',
          textAlign: 'center'
        }}>
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 900,
            fontSize: 14,
            lineHeight: 1,
            letterSpacing: '-0.01em'
          }}>
          NO
          <br />
          SIGNUP
          <br />
          NEEDED
        </div>
      </div>
    </div>
  )
}
